class CustomGravure {
    constructor() {
        this.mainContainer = document.querySelector(".gravure-container .gravure-content");

        this.gravureInput = this.mainContainer?.querySelector(".add-gravure-container #gravure-query");
        this.gravureQuery = "";

        this.floatingGravure = this.mainContainer?.querySelector(".left-container .floating-gravure");
        this.recapCustom = this.mainContainer?.querySelector(".right-container .recap-custom .query");
        this.remainingChar = this.mainContainer?.querySelector(".add-gravure-container #char-nb");
        this.priceElement = this.mainContainer?.querySelector(".right-container .add-to-cart-container .price-value");

        this.openButton = this.mainContainer?.querySelector(".right-container .open-custom");
        this.deleteButton = this.mainContainer?.querySelector(".right-container .recap-custom");
        this.closeButton = this.mainContainer?.querySelector(".gravure-navigation-content .close-container");
        this.cancelButton = this.mainContainer?.querySelector(".validation-container .cancel-container");
        this.validateButton = this.mainContainer?.querySelector(".validation-container .validate-container");
        this.validateCheckbox = this.mainContainer?.querySelector(".validation-container .checkbox-container input[type='checkbox']");

        this.addToCartButton = this.mainContainer?.querySelector(".add-to-cart-container button");

        this.activeGravure = "Sans";
        this.finitionValue = this.addToCartButton?.getAttribute("data-finition");
        this.variantJson = this.addToCartButton?.getAttribute("data-id");;

        this.initEvents();
    }

    initEvents() {
        this.gravureInput?.addEventListener("keydown", (e) => this.verifInput(e));
        this.gravureInput?.addEventListener("input", () => this.updateGravure());

        this.openButton?.addEventListener("click", () => this.openGravure());
        this.closeButton?.addEventListener("click", () => this.resetGravure());
        this.deleteButton?.addEventListener("click", () => this.resetGravure());
        this.cancelButton?.addEventListener("click", () => this.resetGravure());
        this.validateButton?.addEventListener("click", () => {
            if (this.validateCheckbox?.checked) {
                this.closeGravure();
            } else {
                this.validateCheckbox?.classList.add("error");
            }
        });
        this.validateCheckbox?.addEventListener("click", (e) => { e.target.classList.remove("error")});

        this.updateAddToCart();
        this.addToCartButton?.addEventListener("click", () => this.addToCart());
    }

    openGravure() {
        document.body.classList.add("personnalisation-open");
        this.mainContainer?.classList.add("custom");
    }
    closeGravure() {
        this.updateAddToCart();
        document.body.classList.remove("personnalisation-open");
        this.mainContainer?.classList.remove("custom");
    }
    resetGravure() {
        this.gravureInput.value = "";
        this.gravureQuery = "";
        this.floatingGravure.textContent = "";
        this.remainingChar.textContent = 12;

        this.closeGravure();
    }

    verifInput(e) {
        // Autoriser les touches de contrôle
        const allowedKeys = [
            "Backspace", "Delete", "ArrowLeft", "ArrowRight"
            // "ArrowUp", "ArrowDown", "Tab", "Home", "End"
        ];
        if (allowedKeys.includes(e.key)) return;
        
        // Bloquer si caractère non autorisé
        const allowedChars = /^[A-Za-z0-9@&!?\/\-+]$/;
        if (!allowedChars.test(e.key)) {
            e.preventDefault();
            return;
        }
    }
    updateGravure() {
        var query = this.gravureInput?.value;
        var nbChar = query.length;

        this.gravureQuery = query;
        this.floatingGravure.textContent = query;
        this.recapCustom.textContent = '"'+query+'"';
        this.remainingChar.textContent = 12 - nbChar;
    }

    findVariant(active) {
        const normalize = (value) => String(value ?? "").trim().toLowerCase();
        const hasOption = (variant, value) => variant.options?.some(o => normalize(o).startsWith(normalize(value)));

        let result;

        if (productVariants.length === 1) {
            result = productVariants[0];
        } else {
            const candidates = productVariants.filter(v => hasOption(v, active));
            result = (this.finitionValue && candidates.find(v => hasOption(v, this.finitionValue))) || candidates[0];
        }

        if (!result) {
            console.warn(`CustomGravure : aucune variante trouvée pour "${active}"`, productVariants.map(v => v.options));
            result = productVariants[0];
        }

        this.addToCartButton?.setAttribute("data-id", result.id);
        return result;
    }
    verifStock() {
        const wordingDefault = this.addToCartButton?.querySelector(".wording-default");
        const wordingOos = this.addToCartButton?.querySelector(".wording-oos");

        if (this.variantJson?.available == false) {
            this.addToCartButton?.setAttribute("disabled", "true");
            wordingDefault?.classList.remove("visible");
            wordingOos?.classList.add("visible");
        } else {
            this.addToCartButton?.removeAttribute("disabled");
            wordingDefault?.classList.add("visible");
            wordingOos?.classList.remove("visible");
        }
    }
    updatePrice() {
        var price = (this.variantJson.price / 100).toFixed(2);

        console.log(this.variantJson);
        this.priceElement.textContent = price+"€";
    }
    updateActive() {
        if (this.gravureQuery == "") {
            this.mainContainer?.classList.remove("customized");
            this.activeGravure = "Sans";
        } else {
            this.mainContainer?.classList.add("customized");
            this.activeGravure = "Avec";
        }
    }
    updateAddToCart() {
        this.updateActive();
        this.variantJson = this.findVariant(this.activeGravure);
        this.verifStock();
        this.updatePrice();
    }
    async addToCart() {
        console.log("variante = ", this.variantJson);
        var my_properties = {};
        var variantId = String(this.variantJson.id);

        console.log("variantId = ", variantId);
        if (this.gravureQuery == "") {
            my_properties.Gravure = "Aucune";
        } else {
            my_properties.Gravure = this.gravureQuery;
        }
        customAddToCart(variantId, 1, my_properties);
    }
}

window.addEventListener("load", function() {
    const personnalisationCube = new CustomGravure();
});